module.exports = __webpack_public_path__ + "img/home-2.8049eb79.png";